import { gql } from '@apollo/client';

const DELETE_FILE = gql`
  mutation ($input: DeleteFileInput!) {
    deleteFile(input: $input)
  }
`;

export { DELETE_FILE };
